import { render } from "./PrPlanHome.vue?vue&type=template&id=131c4672&scoped=true"
import script from "./PrPlanHome.vue?vue&type=script&lang=js"
export * from "./PrPlanHome.vue?vue&type=script&lang=js"

import "./PrPlanHome.vue?vue&type=style&index=0&id=131c4672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131c4672"]])

export default __exports__